import "./styles.css";
import { useWindowDimensions } from "@hooks";
import addDays from "date-fns/addDays";
import addMonths from "date-fns/addMonths";
import endOfMonth from "date-fns/endOfMonth";
import endOfWeek from "date-fns/endOfWeek";
import startOfMonth from "date-fns/startOfMonth";
import startOfWeek from "date-fns/startOfWeek";
import subDays from "date-fns/subDays";
import { DateRangePicker } from "rsuite";

const predefinedRanges = (placement = "left") => [
  {
    label: "Today",
    value: [new Date(), new Date()],
    placement,
  },
  {
    label: "Yesterday",
    value: [addDays(new Date(), -1), addDays(new Date(), -1)],
    placement,
  },
  {
    label: "This week",
    value: [startOfWeek(new Date()), endOfWeek(new Date())],
    placement,
  },
  {
    label: "Last 7 days",
    value: [subDays(new Date(), 6), new Date()],
    placement,
  },
  {
    label: "Last 30 days",
    value: [subDays(new Date(), 29), new Date()],
    placement,
  },
  {
    label: "This month",
    value: [startOfMonth(new Date()), endOfMonth(new Date())],
    placement,
  },
  {
    label: "Last month",
    value: [
      startOfMonth(addMonths(new Date(), -1)),
      endOfMonth(addMonths(new Date(), -1)),
    ],
    placement,
  },
  {
    label: "This year",
    value: [
      new Date(new Date().getFullYear(), 0, 1),
      new Date(new Date().getFullYear(), 11, 31),
    ],
    placement,
  },
  {
    label: "Last year",
    value: [
      new Date(new Date().getFullYear() - 1, 0, 1),
      new Date(new Date().getFullYear(), 0, 0),
    ],
    placement,
  },
  {
    label: "All time",
    value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date()],
    placement,
  },
];

export default function DateRangeSelection({
  selectedRange,
  handleApplyDateRange,
  isActive,
  containerName,
}) {
  const handleDateRangeConfirm = (range) => {
    if (range && range[0] && range[1]) {
      const startDate = range[0];
      const endDate = range[1];
      handleApplyDateRange(startDate, endDate);
    }
  };

  const handleShortcut = (event) => {
    handleApplyDateRange(event.value[0], event.value[1]);
  };

  const { width: windowWidth } = useWindowDimensions();
  const isNarrowScreen = windowWidth < 500;

  return (
    <DateRangePicker
      format="MMM dd, yyyy"
      character=" to "
      onOk={handleDateRangeConfirm}
      onShortcutClick={handleShortcut}
      value={[
        selectedRange.startDate
          ? new Date(selectedRange.startDate)
          : null,
        selectedRange.endDate
          ? new Date(selectedRange.endDate)
          : null,
      ]}
      ranges={predefinedRanges(isNarrowScreen ? "bottom" : "left")}
      open={isActive}
      showOneCalendar={true}
      editable={false}
      className="relative"
      container={() => document.getElementById(containerName)}
      placement="bottomStart"
      menuClassName="-translate-y-11 -translate-x-2 border-10 border-[var(--surface-primary)] shadow-lg rounded-large"
    />
  );
}
